module.exports = [{"chave":"HOST","valor":"https://wwwsn.bradescofinanciamentos.prebanco.com.br"}]


//////////////////
// WEBPACK FOOTER
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/assets/resource/config.json
// module id = ../../../../../src/assets/resource/config.json
// module chunks = main